<template>
  <!-- center div for map tour step 1 -->
  <div
    id="tour2"
    style="
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60%;
      height: 60%;
    "
  ></div>
</template>

<script src="<%= BASE_URL %>lib/jquery-3.5.1.min.js"></script>
<script>
import Shepherd from "shepherd.js";

export default {
  data() {
    return {
      tour: null,

      generalTourOptions: {
        canClickTarget: false,
        modalOverlayOpeningPadding: 5,
        modalOverlayOpeningRadius: 5,
        highlightClass: "highlightClass",
      },
    };
  },

  mounted() {
    window.addEventListener("resize", () => {
      // this.resizeTourElements();
      this.resizeCSVAutoMatchElements();
    });
  },

  props: ["core"],

  watch: {
    //add watch for resize tour and ui changing elements
    [`core.tableWidthSize`](newVal, oldVal) {
      let me = this,
        timer = null;

      if (newVal != oldVal && me.tour && me.tour.isActive()) {
        // if (newVal == "xs" || oldVal == "xs") {
        //   console.log(newVal,oldVal )
        let currentStepId = me.tour.getCurrentStep().id;
        if (
          currentStepId == "tour_leftbar_step1" ||
          currentStepId == "tour_leftbar_step2" ||
          currentStepId == "tour_table_step1" ||
          currentStepId == "tour_table_step2" ||
          currentStepId == "tour_table_step3" ||
          currentStepId == "tour_map_step2" ||
          currentStepId == "tour_map_step3" ||
          currentStepId == "tour_map_step4"
        ) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            let tmpCurrentStepId = me.tour.getCurrentStep().id;

            me.tour.show(tmpCurrentStepId);
          }, 500);
        }
      }
      // }
    },
  },

  computed: {
    closeButton() {
      return {
        classes: "close",
        text: this.$t("common.welcomeAndAbout.close"),
        action: this.tour.cancel,
      };
    },

    nextButton() {
      return {
        text: this.$t("common.welcomeAndAbout.next"),
        action: this.tour.next,
      };
    },

    doneButton() {
      return {
        text: this.$t("common.welcomeAndAbout.done"),
        action: this.tour.complete,
      };
    },

    prevButton() {
      return {
        text: this.$t("common.welcomeAndAbout.prev"),
        action: this.tour.back,
      };
    },

    fullButtons() {
      return [this.closeButton, this.prevButton, this.nextButton];
    },
  },

  methods: {
    attachNonePointerEventers() {
      //map no event
      $("#map").css("pointer-events", "none");
      //marker no event
      $("#map > div > div > img").css("pointer-events", "none");

      // $("#filterSearchrBar").css("pointer-events", "none");
      $("#filterSearchrBar").find("[role='combobox']").css("pointer-events", "none");
      $("[name='filterSearchrBarItem']")
        .parents("[role='listbox']")
        .css("pointer-events", "none");
    },

    unattachNonePointerEventers() {
      //map no event
      $("#map").css("pointer-events", "auto");
      //marker no event
      $("#map > div > div > img").css("pointer-events", "auto");

      // $("#filterSearchrBar").css("pointer-events", "auto");
      $("#filterSearchrBar").find("[role='combobox']").css("pointer-events", "auto");
      $("[name='filterSearchrBarItem']")
        .parents("[role='listbox']")
        .css("pointer-events", "auto");
    },

    resizeTourElements() {
      if (this.tour && this.tour.isActive()) {
        let currentStepId = this.tour.getCurrentStep().id;
        // this.tour.cancel()
        setTimeout(() => {
          // this.tour.start(currentStepId);
          this.tour.show(currentStepId);
        }, 500);
      }
    },

    resizeCSVAutoMatchElements() {
      let map = this.core;

      try {
        if (
          $("#data_container").length <= 0 ||
          $("#filterSearchrBar").length <= 0 ||
          $("#leftBar").length <= 0
        ) {
          return;
        }

        let top = $("#data_container")[0].offsetTop + $("#filterSearchrBar")[0].offsetTop;
        let left =
          $("#filterSearchrBar")[0].offsetLeft +
          (map.showTable ? $("#leftBar").width() : 0);
        let width = $("#filterSearchrBar")[0].offsetWidth;
        let height =
          $("#filterSearchrBar")[0].offsetHeight +
          $("[name='filterSearchrBarItem']").parents("[role='listbox']").height();

        $("#csv_auto_match_step3_section").css("top", top - 64);
        $("#csv_auto_match_step3_section").css("left", left);
        $("#csv_auto_match_step3_section").css("width", width);
        $("#csv_auto_match_step3_section").css("height", height);

        map.table_container.resizeFilterItem();
        setTimeout(() => {
          map.table_container.resizeFilterItem();
        }, 500);
      } catch (e) {
        if (process.env.NODE_ENV == "development") {
          console.log(e);
        }
      }
    },

    closeOtherElementsWhenOpen() {
      let map = this.core;
      //close table & leftbar
      map.showTable = false;
      map.showLeftBar = false;
      map.setResizeElementTimer(0);
    },

    build({ offset }) {
      if (this.tour != null) {
        this.tour = null;
      }

      this.tour = new Shepherd.Tour({
        useModalOverlay: true,
        keyboardNavigation: false,
        defaultStepOptions: {
          classes: "custom",
          // modalOverlayOpeningPadding: 18,
          popperOptions: {
            //for change style of window
            modifiers: [
              {
                name: "offset",
                options: { offset: offset ? offset : [0, 32] },
              },
            ],
          },
        },
      });
    },

    runTableTourSteps() {
      this.build({});

      this.$nextTick(() => {
        let map = this.core;
        // this.closeOtherElementsWhenOpen();

        this.tour.addSteps([
          {
            attachTo: {
              element: ".tour_table_step1",
              on: "top",
            },
            title: this.$t("common.TableTour.title_addNewRecord"),
            text: this.$t("common.TableTour.content_addNewRecord"),
            buttons: [this.closeButton, this.nextButton],
            ...this.generalTourOptions,
            scrollTo: true,
          },
          {
            attachTo: {
              element: ".tour_table_step2",
              on: "top",
            },
            title: this.$t("common.TableTour.title_columnSettings"),
            text: this.$t("common.TableTour.content_columnSettings"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
            scrollTo: true,
          },
          {
            attachTo: {
              element: ".tour_table_step3",
              on: "top",
            },
            title: this.$t("common.TableTour.title_deleteAllRecord"),
            text: this.$t("common.TableTour.content_deleteAllRecord"),
            buttons: [this.prevButton, this.doneButton],
            ...this.generalTourOptions,
            scrollTo: true,
          },
        ]);
        this.tour.start();
      });
    },

    runAddNCopyDataSteps({ isAdd }) {
      this.build({});

      this.$nextTick(() => {
        let map = this.core;
        // this.closeOtherElementsWhenOpen();

        this.tour.addSteps([
          {
            attachTo: {
              element: "#Add-And-Copy",
              on: "top",
            },
            title: isAdd
              ? this.$t("common.addAndCopyTour.title_add")
              : this.$t("common.addAndCopyTour.title_copy"),
            text: isAdd
              ? this.$t("common.addAndCopyTour.content_add")
              : this.$t("common.addAndCopyTour.content_copy"),
            buttons: [this.doneButton],
            ...this.generalTourOptions,
            scrollTo: true,
          },
        ]);
        this.tour.start();
      });
    },

    runLeftBarTourSteps({ emptyRecord }) {
      this.build({ offset: [0, 36] });

      let map = this.core;
      if (emptyRecord) {
        map.leftBar.searchResult = [
          {
            caddress: "",
            cdescription: null,
            cname: "渣華道",
            eaddress: "",
            edescription: null,
            ename: "JAVA ROAD",
            faciType: null,
            id: "10897",
            nameStatus: "E",
            score: 17510.654296875,
            type: "ST",
            layer: null,
            leaflet_id: null,
          },
        ];
      }

      this.tour.addSteps([
        {
          id: "tour_leftbar_step1",
          when: {
            show() {
              $("#leftBarTabsItems").scrollTop(0);
            },
          },
          attachTo: {
            element: ".tour_leftbar_step1",
            on: "bottom",
          },
          title: this.$t("common.LeftBarTour.title_addData"),
          text: this.$t("common.LeftBarTour.content_addData"),
          buttons: [this.closeButton, this.nextButton],
          ...this.generalTourOptions,
          // scrollTo: true,
        },
        {
          id: "tour_leftbar_step2",
          when: {
            show() {
              $("#leftBarTabsItems").scrollTop(0);
            },
          },
          attachTo: {
            element: ".tour_leftbar_step2",
            on: "bottom",
          },
          title: this.$t("common.LeftBarTour.title_copyData"),
          text: this.$t("common.LeftBarTour.content_copyData"),
          buttons: [this.prevButton, this.doneButton],
          ...this.generalTourOptions,
          // scrollTo: true,
        },
      ]);

      this.tour.on("cancel", function () {
        if (emptyRecord) {
          map.leftBar.searchResult = [];
        }
      });

      this.tour.on("complete", function () {
        if (emptyRecord) {
          map.leftBar.searchResult = [];
        }
      });

      this.tour.start();
      // setTimeout(() => this.tour.start(), 500);
    },

    runImportSteps() {
      this.build({});

      this.$nextTick(() => {
        let map = this.core;
        // this.closeOtherElementsWhenOpen();

        this.tour.addSteps([
          {
            attachTo: {
              element: map.import.$refs.tour_format,
              on: "bottom",
            },
            title: this.$t("common.importTour.title_fileFormat"),
            text: this.$t("common.importTour.content_fileFormat"),
            buttons: [this.closeButton, this.nextButton],
            ...this.generalTourOptions,
            scrollTo: true,
          },
          {
            attachTo: {
              element: map.import.$refs.tour_file.$el,
              on: "bottom",
            },
            title: this.$t("common.importTour.title_fileSelect"),
            text: this.$t("common.importTour.content_fileSelect"),
            buttons: [this.prevButton, this.doneButton],
            ...this.generalTourOptions,
            scrollTo: true,
          },
        ]);
        this.tour.start();
      });
    },

    runCSVAutoMatchTour() {
      this.build({});

      this.$nextTick(() => {
        let me = this;
        let map = this.core;
        let tmpEnableAutoMatchSearch_Location =
          map.import.$data.enableAutoMatchSearch_Location;

        let tmpShowTable = map.showTable;
        // this.closeOtherElementsWhenOpen();

        let tmpTableEnabledFilter = map.table_container.enabledFilter;

        map.import.$data.tourRunning = true;
        this.tour.addSteps([
          //step 1
          {
            when: {
              show: () => {
                map.import.$data.enableAutoMatchSearch_Location = true;
              },
            },
            attachTo: {
              element: map.import.$refs.tour_step1.$el,
              on: "bottom",
            },
            title: this.$t("common.CSVAutoMatchTour.title_step1"),
            text: this.$t("common.CSVAutoMatchTour.content_step1"),
            buttons: [this.closeButton, this.nextButton],
            ...this.generalTourOptions,
            scrollTo: true,
          },

          //step2
          {
            when: {
              show: () => {
                if (!tmpTableEnabledFilter) {
                  map.table_container.enabledFilter = true;
                }

                map.import.$data.import_modal = true;
                map.setShowTable({ val: true, openFromAutoCSVMatch: true });
              },
            },
            classes: "tour_step2",
            attachTo: {
              element: map.import.$refs.tour_step2,
              on: "top",
            },
            title: this.$t("common.CSVAutoMatchTour.title_step2"),
            text: this.$t("common.CSVAutoMatchTour.content_step2"),
            buttons: [this.closeButton, this.prevButton, this.nextButton],
            ...this.generalTourOptions,
            scrollTo: true,
          },

          //step3
          {
            when: {
              show: () => {
                map.import.$data.import_modal = false;

                map.table_container.$refs.tour_step3.$data.isFocused = true;
                map.table_container.$refs.tour_step3.$data.isMenuActive = true;

                me.attachNonePointerEventers();
                me.resizeCSVAutoMatchElements();

                setTimeout(() => {
                  me.attachNonePointerEventers();
                  me.resizeCSVAutoMatchElements();
                }, 100);
              },

              hide: function () {
                map.table_container.$refs.tour_step3.$data.isFocused = false;
                map.table_container.$refs.tour_step3.$data.isMenuActive = false;
                me.unattachNonePointerEventers();
              },
              destroy: () => {
                map.table_container.$refs.tour_step3.$data.isFocused = false;
                map.table_container.$refs.tour_step3.$data.isMenuActive = false;
                me.unattachNonePointerEventers();
              },
            },
            attachTo: {
              // element: map.table_container.$refs.tour_step3.$el,
              element: "#csv_auto_match_step3_section",
              on: "top",
            },
            title: this.$t("common.CSVAutoMatchTour.title_step3"),
            text: this.$t("common.CSVAutoMatchTour.content_step3"),
            buttons: [this.closeButton, this.prevButton, this.doneButton],
            ...this.generalTourOptions,
            scrollTo: true,
          },
        ]);

        this.tour.on("cancel", function () {
          map.import.$data.tourRunning = false;

          map.import.$data.enableAutoMatchSearch_Location = tmpEnableAutoMatchSearch_Location;
          map.table_container.enabledFilter = tmpTableEnabledFilter;
          map.import.$data.import_modal = true;
          map.setShowTable({
            val: tmpShowTable,
            openFromAutoCSVMatch: true,
          });
        });

        this.tour.on("complete", function () {
          map.import.$data.tourRunning = false;

          map.import.$data.enableAutoMatchSearch_Location = tmpEnableAutoMatchSearch_Location;
          map.table_container.enabledFilter = tmpTableEnabledFilter;
          map.import.$data.import_modal = true;
          map.setShowTable({
            val: tmpShowTable,
            openFromAutoCSVMatch: true,
          });
        });

        map.notShowTableTour = true;
        this.tour.start();

        this.tour.on("cancel", function () {
          map.notShowTableTour = false;
        });

        this.tour.on("complete", function () {
          map.notShowTableTour = false;
        });
      });
    },

    runColumnSettingsTourSteps() {
      this.build({});

      let map = this.core;
      if (map.dynamicFields.length == 0) {
        map.table_container.enableColumnSettingsExample = true;
      }

      setTimeout(() => {
        // this.closeOtherElementsWhenOpen();

        this.tour.addSteps([
          {
            attachTo: {
              element: ".tour_columnsettings_step1",
              on: "bottom",
            },
            title: this.$t("common.colSetting.title_remove"),
            text: this.$t("common.colSetting.content_remove"),
            buttons: [this.closeButton, this.nextButton],
            ...this.generalTourOptions,
          },

          {
            attachTo: {
              element: ".tour_columnsettings_step2",
              on: "bottom",
            },
            title: this.$t("common.colSetting.title_manage"),
            text: this.$t("common.colSetting.content_manage"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            attachTo: {
              element: ".tour_columnsettings_step3",
              on: "top",
            },
            title: this.$t("common.colSetting.title_new"),
            text: this.$t("common.colSetting.content_new"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            attachTo: {
              element: ".tour_columnsettings_step4",
              on: "bottom",
            },
            title: this.$t("common.colSetting.title_layerName"),
            text: this.$t("common.colSetting.content_layerName"),
            buttons: [this.prevButton, this.doneButton],
            ...this.generalTourOptions,
          },
        ]);

        this.tour.on("cancel", function () {
          map.table_container.enableColumnSettingsExample = false;
        });

        this.tour.on("complete", function () {
          map.table_container.enableColumnSettingsExample = false;
        });

        this.tour.start();
      }, 500);
    },

    runMapTourSteps() {
      let me = this;
      this.build({});

      this.$nextTick(() => {
        let map = this.core,
          tour = this.tour;

        // console.log(tour);

        this.closeOtherElementsWhenOpen();

        this.tour.addSteps([
          {
            id: "tour_map_step2",
            when: {
              show() {
                map.map_tools_visible = true;
                //hide menu
                $("div[role='menu']").css("visibility", "inherit");
              },
            },
            attachTo: {
              element: ".tour_map_step2",
              on: "bottom",
            },
            title: this.$t("common.welcomeAndAbout.saveTitle"),
            text: this.$t("common.welcomeAndAbout.saveDescription"),
            buttons: [this.closeButton, this.nextButton],
            ...this.generalTourOptions,
          },

          {
            id: "tour_map_step3",
            when: {
              show() {
                map.map_tools_visible = true;
                //hide menu
                $("div[role='menu']").css("visibility", "inherit");
              },
            },
            attachTo: {
              element: ".tour_map_step3",
              on: "bottom",
            },
            title: this.$t("common.welcomeAndAbout.importTitle"),
            text: this.$t("common.welcomeAndAbout.importDescription"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            id: "tour_map_step4",
            when: {
              show() {
                map.map_tools_visible = true;
                //hide menu
                $("div[role='menu']").css("visibility", "inherit");
              },
            },
            attachTo: {
              element: ".tour_map_step4",
              on: "bottom",
            },
            title: this.$t("common.welcomeAndAbout.downloadTitle"),
            text: this.$t("common.welcomeAndAbout.downloadDescription"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            attachTo: {
              element: "#show_table",
              on: "auto",
            },
            title: this.$t("common.welcomeAndAbout.manageDataInTableTitle"),
            text: this.$t("common.welcomeAndAbout.manageDataInTableDescription"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            id: "tour_map_step1",
            when: {
              show() {
                me.attachNonePointerEventers();
              },
              hide() {
                // console.log("hide");
                // map.map_tools_visible = true;
              },
            },
            attachTo: {
              element: ".tour2",
              on: "top",
            },
            title: this.$t("common.welcomeAndAbout.mapTitle"),
            text: this.$t("common.welcomeAndAbout.mapDescription"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            when: {
              show() {
                //show menu
                $("div[role='menu']").css("visibility", "hidden");
              },
            },
            attachTo: {
              element: map.searchBar.$refs.searchBarInput.$el,
              on: "auto",
            },
            title: this.$t("common.welcomeAndAbout.locationSearchTitle"),
            text: this.$t("common.welcomeAndAbout.locationSearchDescription"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            attachTo: {
              element: ".leaflet-control-layers-toggle",
              on: "auto",
            },
            title: this.$t("common.welcomeAndAbout.switchMapTitle"),
            text: this.$t("common.welcomeAndAbout.switchMapDescription"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            attachTo: {
              element: ".leaflet-draw.leaflet-control",
              on: "auto",
            },
            title: this.$t("common.welcomeAndAbout.editOrDeleteGeoTaggedDataTitle"),
            text: this.$t("common.welcomeAndAbout.editOrDeleteGeoTaggedDataDescription"),
            buttons: this.fullButtons,
            ...this.generalTourOptions,
          },

          {
            attachTo: {
              element: ".leaflet-control.leaflet-bar.customViewPointControlContainer",
              on: "auto",
            },
            title: this.$t("common.welcomeAndAbout.setDefaultExtentTitle"),
            text: this.$t("common.welcomeAndAbout.setDefaultExtentDescription"),
            buttons: [this.prevButton, this.doneButton],
            ...this.generalTourOptions,
          },
        ]);

        this.tour.on("cancel", function () {
          me.unattachNonePointerEventers();

          //show menu
          $("div[role='menu']").css("visibility", "inherit");

          map.map_tools_visible = false;
          map.map_tools_close_on_click = true;
        });

        this.tour.on("complete", function () {
          me.unattachNonePointerEventers();

          //show menu
          $("div[role='menu']").css("visibility", "inherit");

          map.map_tools_visible = false;
          map.map_tools_close_on_click = true;
        });

        map.map_tools_visible = true;
        map.map_tools_close_on_click = false;
        this.$nextTick(() => {
          //hide menu
          $("div[role='menu']").css("visibility", "hidden");
          // me.tour.start();
          setTimeout(() => {
            me.tour.start();
          }, 500);
        });
      });
    },

    runExportSteps() {
      this.build({});

      this.$nextTick(() => {
        this.tour.addSteps([
          {
            attachTo: {
              element: ".export_formats",
              on: "bottom",
            },
            title: this.$t("common.exportTour.title_fileFormat"),
            text: this.$t("common.exportTour.content_fileFormat"),
            buttons: [this.doneButton],
            ...this.generalTourOptions,
          },
        ]);
        this.tour.start();
      });
    },
  },
};
</script>

<style lang="scss">
@import "~shepherd.js/dist/css/shepherd.css";

.highlightClass {
  //   padding: 10px !important;

  //   .div {
  //     padding: 20px !important;
  //   }
}

.custom {
  .shepherd-arrow {
    z-index: 0 !important;
  }

  //change window arrow from text to icon
  .shepherd-arrow:before {
    content: url("../../public/lib/images/arrow.svg");
    display: inline-block;
    background: none !important;
  }

  //condition to change arrow
  &.shepherd-element[data-popper-placement^="top"] {
    .shepherd-arrow:before {
      transform: rotate(270deg);
      bottom: -20px;
      left: -3px;
    }
  }

  &.shepherd-element[data-popper-placement^="right"] {
    .shepherd-arrow:before {
      transform: rotate(0deg);
      left: -20px;
      bottom: 3px;
    }
  }

  &.shepherd-element[data-popper-placement^="bottom"] {
    .shepherd-arrow:before {
      transform: rotate(90deg);
      top: -20px;
    }
  }

  &.shepherd-element[data-popper-placement^="left"] {
    .shepherd-arrow:before {
      transform: rotate(180deg);
      right: -20px;
      top: 3px;
    }
  }

  //dialog style
  .shepherd-content {
    .shepherd-header {
      background-color: #183952;
      .shepherd-title {
        color: #fff;
      }
    }
    //fix title too long - overlay
    .shepherd-title {
      flex: auto !important;
    }

    .shepherd-text {
      overflow: auto;
    }

    .shepherd-footer {
      .shepherd-button {
        background-color: #343a40;
        color: #fff;
        font-size: 0.8em;
        padding: 5px 8px;

        &:hover {
          color: #fff;
        }

        &.close {
          color: #000;
          background-color: #fff;

          &:hover {
            color: #000;
          }
        }
      }
    }
  }
}
</style>
